module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.expanded) ? _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.expanded = true
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonLabel))]) : _vm._e(), _vm._v(" "), (_vm.expanded) ? _c('div', {
    staticClass: "feed-post",
    attrs: {
      "id": "feed-add-new"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.headlineLabel))]), _vm._v(" "), _c('form', [(_vm.isOnAGameProject) ? [_c('label', [_c('span', [_vm._v("Post As")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPostAs),
      expression: "selectedPostAs"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPostAs = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "developer"
    }
  }, [_vm._v(_vm._s(_vm.developerAlias))]), _vm._v(" "), _vm._l((_vm.gameProjects), function(game) {
    return _c('option', {
      domProps: {
        "value": game.id
      }
    }, [_vm._v("Game: " + _vm._s(game.alias))])
  })], 2)])] : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPostSubject),
      expression: "newPostSubject"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Subject (optional)"
    },
    domProps: {
      "value": (_vm.newPostSubject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPostSubject = $event.target.value
      }
    }
  }), _vm._v(" "), _c('markdown-editor', {
    attrs: {
      "placeholder": "Post Content"
    },
    model: {
      value: (_vm.newPostContent),
      callback: function($$v) {
        _vm.newPostContent = $$v
      },
      expression: "newPostContent"
    }
  }), _vm._v(" "), (!_vm.helpShown) ? _c('div', {
    staticClass: "help-button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showHelpRollout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-question-circle"
  }), _vm._v(" Help submitting a DevLog\n            ")]) : _c('div', {
    staticClass: "help-rollout"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "help-button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hideHelpRollout()
      }
    }
  }, [_vm._v("Hide Help")])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitNewPost($event)
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.expanded = false
      }
    }
  }, [_vm._v("Cancel")])], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                    A Developer's Log (or "), _c('em', [_vm._v("DevLog")]), _vm._v(" for short) is a bit like a diary or Blog post for your game\n                    development related topics. It's not a recruitment tool (that is what Classifieds are for)\n                    but anything else about your game dev journey that you want to write about is fair game.\n                    Some might use it to write about an interesting thing they worked on, or a gamedev challenge\n                    they faced and how they solved it, or something they just learned.\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c664fb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/HomeFeed/HomeFeedNewPostForm.vue
// module id = 833
// module chunks = 2